/**
 * webview 工具集合
 * @author Carson
 * @date 2021/4/13
 * */
import { resetHost } from '@/utils/url'
// iOS webkit 存储
export const WebkitSetLocalStorageMessage = '__webkit_set_local_storage__'
export const WebkitGetLocalStorageMessage = '__webkit_get_local_storage__'
export const WebkitReceiveLocalStorageMessage = '__webkit_receive_local_storage__'

// 获取当前系统可用的函数
function getNativeFramework() {
    if (window.webkit && window.webkit.messageHandlers) {
        // ios WKWebview
        return window.webkit.messageHandlers
    }
    return window
}

const nativeFramework = getNativeFramework()



/**
 * @param { string } key
 * @param { any } value
 * */
export function webkitSetLocalStorage(key, value) {
    if (key && value && nativeFramework.setLocalStorage && nativeFramework.setLocalStorage.postMessage) {
        const data = { key, value }
        nativeFramework.setLocalStorage.postMessage(JSON.stringify(data))
        return data
    }
    return null
}

/**
 * @param { string } key
 * */
export function webkitGetLocalStorage(key) {
    console.log('post message')
    if (key && nativeFramework.getLocalStorage && nativeFramework.getLocalStorage.postMessage) {
        nativeFramework.getLocalStorage.postMessage(key)
    }
}

const webkitReceiveLocalStorage = (response) => {
    console.log('receive webkit message', response)
    window.postMessage({
        key: '__webkit_parent_receive_local_storage__',
        value: response
    }, window.location.origin)
}

window.webkitReceiveLocalStorage = webkitReceiveLocalStorage
